/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Title_AccentInputs */

const tr_landing_community_title_accent = /** @type {(inputs: Landing_Community_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hem topluluk, hem destek.`)
};

const en_landing_community_title_accent = /** @type {(inputs: Landing_Community_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community and support in one.`)
};

const de_landing_community_title_accent = /** @type {(inputs: Landing_Community_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community und Support zugleich.`)
};

const ru_landing_community_title_accent = /** @type {(inputs: Landing_Community_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`И сообщество, и поддержка.`)
};

/**
* | output |
* | --- |
* | "Community and support in one." |
*
* @param {Landing_Community_Title_AccentInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_title_accent = /** @type {((inputs?: Landing_Community_Title_AccentInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Title_AccentInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_title_accent(inputs)
	if (locale === "de") return de_landing_community_title_accent(inputs)
	if (locale === "ru") return ru_landing_community_title_accent(inputs)
	return tr_landing_community_title_accent(inputs)
});